import { Layout } from "antd"
import logoMax from "../../assets/images/logo_UMC_maxi.svg"
import logoMin from "../../assets/images/logo_UMC_mini.svg"
import buttonMax from "../../assets/images/button_menu_maxi.svg"
import buttonMin from "../../assets/images/button_menu_mini.svg"
import linkIcon from "../../assets/images/themed-icons/light-icon-link.svg"
import networkIcon from "../../assets/images/icon_network.svg"
import oxeIcon from "../../assets/images/icon_OXE.svg"
import settingsIcon from "../../assets/images/icon_settings.svg"
import sipTrunkIcon from "../../assets/images/icon_sip_trunk.svg"
import subscriptionIcon from "../../assets/images/icon_subscriptions.svg"
import usersIcon from "../../assets/images/icon_users.svg"
import wbmIcon from "../../assets/images/icon_wbm.svg"
import rainbowIcon from "../../assets/images/icon_rainbow.svg"
import icon_whatsnew from '../../assets/images/icon_whatsnew.svg'
import UMCButton from "../common/UMCButton"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setCurrentMergedData, setSelectedApplication } from "../../store/reducers/CommonReducer"
import { USERS_CONFIG, EXPERT_CONFIG, FLEET_DASHBOARD, OXE_LOGIN, SIP_TRUNK, SUBSCRIPTION, CC_PRODUCT_ID, PROJECT_ID, IS_POD, RAINBOW, LINKS, WHATS_NEW, SYSTEM } from "../../utils/Constants"
import { useWindowSize } from "../customHooks/useWindowSize"
import { PURPLE, WHITE, getSideBarMaxTextLength } from "../../styles/styleUtils"
import { LinkOutlined } from "@ant-design/icons"
import { FLEET_URL, MYPORTAL_URL, RAINBOW_URL } from "../../utils/Config"
import { getSessionItem } from "../../utils/storageUtils"
import { getTranslated } from "../../utils/CommonUtils"
import confirmModal from "../common/confirmModal"
import { deleteDECTOnTabChange } from "../../store/actions/UUMActions"
import { useNavigate } from "react-router-dom"
import { sendGTMEvent } from "../../utils/GTMUtils"


const siderStyle = {
    textAlign: "center",
    color: WHITE,
    backgroundColor: PURPLE,
}

const UMCSidebar = (props) => {

    const [collapsed, setCollapsed] = useState(false)
    const dict = useSelector((state) => state.common.dict)
    const [width, height] = useWindowSize()
    const [rightClickDDVisible, setRightClickDDVisible] = useState(false)
    const [position, setPosition] = useState({ x: 0, y: 0 })
    // const [appSelected, setAppSelected] = useState()
    
    const selectedApp = useSelector((state) => state.common.selectedApp)
    const oxeUmcConnected = useSelector((state) => state.oxe.oxeUmcConnected)
    const oxeAuthStatus = useSelector((state) => state.oxe.oxeAuthStatus)
    const oxeAndClientInfo = useSelector(state => state.oxe.oxeAndClientInfo)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseMergeData = useSelector((state) => state.common.baseMergeData)
    const validateForDECTUserDelete = useSelector((state) => state.uum.validateForDECTUserDelete)
    const isUnSavedDataExists = useSelector((state) => state.common.isUnSavedDataExists)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const dropdownRef = useRef(null)

    useEffect(() => {

        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setRightClickDDVisible(false)
            }
        }
        document.addEventListener('click', handleClickOutside)
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [])

    useEffect(() => {
        if (width < 850) setCollapsed(true)
        else setCollapsed(false)
    }, [width])

    // To be removed
    // useEffect(() => {
    //     // if(!props.unAuth)
    //     setAppSelected(selectedApp)
    // }, [selectedApp])

    // useEffect(() => {
    //      if (appSelected) {

    //         // Send custom event to GA
    //         // ReactGA.send({ hitType: "pageview", page: `/${appSelected}`, title: document.title })

    //         // Push to GTM datalayer
    //         // sendGTMEvent({
    //         //     event: 'page_view',
    //         //     page_path: `${window.location.origin}/${selectedApp?.toLowerCase()}`,
    //         //     page_title: (selectedApp || document.title)?.toLowerCase(),
    //         //     page_test: `test page ${selectedApp}`, // custom metrics
    //         //     page_demo: "Demo"
    //         // })
    //         //  sendGTMEvent({
    //         //      event: "umc_app_selection",
    //         //      selected_item: (selectedApp === OXE_LOGIN) ? SYSTEM : selectedApp
    //         //  })
    //     }
    // }, [appSelected])

    const handleAppSelect = (app) => {
        if (app !== selectedApp) {
            // setAppSelected(app)
             sendGTMEvent({
                 event: "umc_app_selection",
                 selected_item: (app === OXE_LOGIN) ? SYSTEM : app
             })

            if (app === FLEET_DASHBOARD || app === SUBSCRIPTION || app === RAINBOW || !currentMergedData ||
                ((selectedApp === USERS_CONFIG && !isUnSavedDataExists) || (selectedApp !== USERS_CONFIG && (JSON.stringify(currentMergedData) === JSON.stringify(baseMergeData))))) {
                handleAppSelectAction(app)
            } else {
                confirmModal({
                    title: "MSG_LEAVE_PAGE",
                    content: "MSG_LOSE_CONFIG",
                    onOk: () => {
                        if (validateForDECTUserDelete) {
                            dispatch(deleteDECTOnTabChange(() => {
                                dispatch(setCurrentMergedData(null))
                                handleAppSelectAction(app)
                            }))
                        } else {
                            dispatch(setCurrentMergedData(null))
                            handleAppSelectAction(app)
                        }
                    }
                })
            }
        }
    }

    const handleAppSelectAction = (app) => {

        if (app === FLEET_DASHBOARD)
            FLEET_URL && window.open(`${FLEET_URL}/details_page/${getSessionItem(CC_PRODUCT_ID)}`, '_blank').focus()
        else if (app === SUBSCRIPTION)
            MYPORTAL_URL && window.open(`${MYPORTAL_URL}subscriptionview?c__projectId=${getSessionItem(PROJECT_ID)}&c__isPod=${getSessionItem(IS_POD)}`, '_blank').focus()
        else if (app === RAINBOW)
            RAINBOW_URL && window.open(`${RAINBOW_URL}`, '_blank').focus()
        else if (app !== selectedApp) {
            navigate(`/${app}`)
            dispatch(setSelectedApplication(app))
        }
    }

    // To be removed
    function handleTextOverflow(text) {
        const maxLength = getSideBarMaxTextLength(width)
        const isTruncated = text.length > maxLength
        const truncated = isTruncated ? text.slice(0, maxLength - 3) + "..." : text

        return isTruncated ? (
            <span title={text}>
                {truncated}
            </span>
        ) : truncated
    }

    const handleContextMenu = (e) => {
        if(oxeAuthStatus) {
            e.preventDefault()
            setPosition({ x: e.pageX, y: e.pageY })
            setRightClickDDVisible(true)
        }
    }


    return <Layout.Sider
        style={siderStyle}
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={250}
    >
        <div>
            <div id="mainNav" className={collapsed ? "expand" : "collapse"}>
                <div id="logoField">
                    {!collapsed ?
                        <span>
                            <img src={logoMax} alt="LogoUMC" className={"logo-umc-min"} />
                            <UMCButton onClick={() => setCollapsed(!collapsed)} icon={<img src={buttonMin} alt={getTranslated(dict, "LABEL_COLLAPSE")} title={getTranslated(dict, "LABEL_COLLAPSE")} />} className="toggleButton" />
                        </span>
                        : <span>
                            <UMCButton onClick={() => setCollapsed(!collapsed)} icon={<img src={buttonMax} alt={getTranslated(dict, "LABEL_EXPAND")} title={getTranslated(dict, "LABEL_EXPAND")} />} className="toggleButton" />
                            <img src={logoMin} alt="LogoUMC" className={"logo-umc-max"} />
                        </span>}
                </div>
                {!props.unAuth && <nav>
                    <div id="OXEStatus">

                        <UMCButton
                            className={`button buttonSystem ${selectedApp === OXE_LOGIN ? "active" : ""} ${(oxeUmcConnected || oxeUmcConnected === undefined) ? "" : "error-status-bg"}`}
                            type="primary"
                            icon={<img src={oxeIcon} alt="OXE icon" />}
                            onClick={() => handleAppSelect(OXE_LOGIN)}
                            label={<span className="app-label link-label text-overflow-word-wrap">
                                {collapsed ? "" : oxeAndClientInfo?.clientName || getSessionItem(CC_PRODUCT_ID)}
                                {(oxeUmcConnected || oxeUmcConnected === undefined) ? "" : collapsed ? "" : <div>{getTranslated(dict, "LABEL_DISCONNECTED")}</div>}
                            </span>}
                            title={collapsed ? oxeAndClientInfo?.clientName || getSessionItem(CC_PRODUCT_ID) : ""}
                        />
                        <div id="networkIcon">{oxeAuthStatus ? <img src={networkIcon} alt="Network icon" /> : <></>}</div>
                    </div>
                    <div id="configMenu">
                        <UMCButton
                            disabled={!oxeAuthStatus/* || !oxeUmcConnected*/}
                            className={`button buttonMenu ${selectedApp === USERS_CONFIG ? "active" : ""}`}
                            onClick={() => handleAppSelect(USERS_CONFIG)}
                            icon={<img src={usersIcon} alt="Users icon" />}
                            label={<span className="app-label link-label text-overflow-word-wrap">{collapsed ? "" : (getTranslated(dict, "APP_EASY_UUM"))}</span>}
                            title={collapsed ? getTranslated(dict, "APP_EASY_UUM") : ""}
                        />
                        <UMCButton
                            disabled={!oxeAuthStatus/* || !oxeUmcConnected*/}
                            className={`button buttonMenu ${selectedApp === SIP_TRUNK ? "active" : ""}`}
                            onClick={(e) => handleAppSelect(SIP_TRUNK)}
                            icon={<img src={sipTrunkIcon} alt="SIP trunk icon" />}
                            label={<span className="app-label link-label text-overflow-word-wrap">{collapsed ? "" : (getTranslated(dict, "APP_SIP_TRUNK"))}</span>}
                            title={collapsed ? getTranslated(dict, "APP_SIP_TRUNK") : ""}
                        />
                        <UMCButton
                            disabled={!oxeAuthStatus/* || !oxeUmcConnected*/}
                            className={`button buttonMenu ${selectedApp === EXPERT_CONFIG ? "active" : ""}`}
                            onClick={() => handleAppSelect(EXPERT_CONFIG)}
                            icon={<img src={wbmIcon} alt="WBM icon" />}
                            label={<span className="app-label link-label text-overflow-word-wrap">{collapsed ? "" : (getTranslated(dict, "APP_EXPERT_CONF"))}</span>}
                            title={collapsed ? getTranslated(dict, "APP_EXPERT_CONF") : ""}
                            onContextMenu={handleContextMenu}
                        />
                        {rightClickDDVisible && (
                            <div
                                ref={dropdownRef}
                                className="right-clk-dd"
                                style={{
                                    top: position.y,
                                    left: position.x,
                                }}
                            >
                                <div onClick={() => window.open(`${window.location.origin}/${EXPERT_CONFIG}`, '_blank')}>{getTranslated(dict, "LABEL_NEW_TAB")}</div>
                            </div>
                        )}
                        <UMCButton
                            disabled={!oxeAuthStatus}
                            className={`button buttonMenu ${selectedApp === FLEET_DASHBOARD ? "active" : ""}`}
                            onClick={() => handleAppSelect(FLEET_DASHBOARD)}
                            icon={<img src={settingsIcon} alt="Fleet icon" />}
                            label={collapsed ? "" : <span className="app-label">
                                <span className="link-label text-overflow-word-wrap">
                                    <span>{(getTranslated(dict, "APP_FLEET"))}</span>
                                </span>
                                <LinkOutlined className="link-icon" />
                            </span>}
                            title={collapsed ? getTranslated(dict, "APP_FLEET") : ""}
                        />
                        <UMCButton
                            disabled={getSessionItem(IS_POD) === "0" || (!oxeAuthStatus)}
                            className={`button buttonMenu ${selectedApp === SUBSCRIPTION ? "active" : ""}`}
                            onClick={() => handleAppSelect(SUBSCRIPTION)}
                            icon={<img src={subscriptionIcon} alt="subscription" />}
                            label={collapsed ? "" : <span className="app-label">
                                <span className="link-label text-overflow-word-wrap">
                                    <span>{(getTranslated(dict, "APP_SUBSCRIPTIONS"))}</span>
                                </span>
                                <LinkOutlined className="link-icon" />
                            </span>}
                            title={collapsed ? getTranslated(dict, "APP_SUBSCRIPTIONS") : ""}
                        />
                    </div>
                </nav>}
            </div>
            <div id="bottom-nav" className={collapsed ? "expand" : "collapse"}>
                <nav>
                    <div id="generalMenu">
                        <UMCButton
                            className={`button buttonMenu`}
                            onClick={() => handleAppSelect(RAINBOW)}
                            icon={<img src={rainbowIcon} alt="Rainbow" style={{ height: "22px" }} />}
                            label={collapsed ? "" : <span className="app-label">
                                <span className="link-label text-overflow-word-wrap">
                                    <span>{(getTranslated(dict, "APP_RAINBOW_ADMIN"))}</span>
                                </span>
                                <LinkOutlined className="link-icon" />
                            </span>}
                            title={collapsed ? getTranslated(dict, "APP_RAINBOW_ADMIN") : ""}
                        />
                         <UMCButton
                            className={`button buttonMenu ${selectedApp === WHATS_NEW ? "active" : ""}`}
                            onClick={() => handleAppSelect(WHATS_NEW) }
                            icon={<img src={icon_whatsnew} alt="News icon" />}
                            label={<span className="app-label link-label text-overflow-word-wrap">{collapsed ? "" : getTranslated(dict, "APP_WHAT'S_NEW")}</span>}
                            title={collapsed ? getTranslated(dict, "APP_WHAT'S_NEW") : ""}
                        />
                        <UMCButton
                            className={`button buttonMenu ${selectedApp === LINKS ? "active" : ""}`}
                            onClick={() => handleAppSelect(LINKS)}
                            icon={<img src={linkIcon} alt="Links icon" />}
                            type="primary"
                            label={<span className="app-label link-label text-overflow-word-wrap">{collapsed ? "" : (getTranslated(dict, "APP_LINKS"))}</span>}
                            title={collapsed ? getTranslated(dict, "APP_LINKS") : ""}
                        />
                        {/* <UMCButton icon={<img src={helpIcon} alt="About icon" />} type="primary" label={collapsed ? "" : "About / Help"} className="button buttonMenu" /> */}
                    </div>
                </nav>
            </div>
        </div>
    </Layout.Sider>
}

export default UMCSidebar